import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107103Status: 'idle',
    startProcess107103Error: undefined as any,
    loadUserParamsProcess107103Status: 'idle',
    loadUserParamsProcess107103Error: undefined as any,

    process107103List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107103 = createAsyncThunk('process107103Slice/startProcess107103', async ({ process107103 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107103/`,
        prepareData(process107103),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107103Status } = getState().process107103Slice
        return startProcess107103Status !== 'pending'
    }
})

export const loadUserParamsProcess107103 = createAsyncThunk('process107103Slice/loadUserParamsProcess107103', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107103/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107103Status } = getState().process107103Slice
        return loadUserParamsProcess107103Status !== 'pending'
    }
})

const Process107103Slice = createSlice({
    name: 'process107103Slice',
    initialState,
    reducers: {
        resetstartProcess107103: (state) => {
            state.job = undefined
            state.startProcess107103Error = undefined
        },
        resetstartProcess107103Error: (state) => {
            state.startProcess107103Error = undefined
        },
        resetloadUserParamsProcess107103: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107103Error = undefined
        },
        resetloadUserParamsProcess107103Error: (state) => {
            state.loadUserParamsProcess107103Error = undefined
        },
        removeFromProcess107103ListById: (state, action) => {
            state.process107103List = state.process107103List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107103ListByIds: (state, action) => {
            state.process107103List = state.process107103List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107103List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107103Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107103List = []
            state.startProcess107103Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107103.pending, (state) => {
            state.startProcess107103Status = 'pending'
            state.startProcess107103Error = undefined
        })
        builder.addCase(startProcess107103.fulfilled, (state, action) => {
            state.startProcess107103Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107103.rejected, (state, action) => {
            state.startProcess107103Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107103Error = action.error.message
            } else {
                state.startProcess107103Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107103.pending, (state) => {
            state.loadUserParamsProcess107103Status = 'pending'
            state.loadUserParamsProcess107103Error = undefined
        })
        builder.addCase(loadUserParamsProcess107103.fulfilled, (state, action) => {
            state.loadUserParamsProcess107103Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107103.rejected, (state, action) => {
            state.loadUserParamsProcess107103Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107103Error = action.error.message
            } else {
                state.loadUserParamsProcess107103Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107103,
    resetstartProcess107103Error,
    resetloadUserParamsProcess107103,
    resetloadUserParamsProcess107103Error,
    removeFromProcess107103ListById,
    removeFromProcess107103ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107103Slice.actions
export default Process107103Slice.reducer
